/**
 * Sistema de logging profissional
 * - Em desenvolvimento: loga tudo
 * - Em produção: apenas erros
 */

const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  // eslint-disable-next-line no-console -- logger centralizado para dev
  log: (...args: unknown[]) => isDev && console.log(...args),
  warn: (...args: unknown[]) => isDev && console.warn(...args),
  // eslint-disable-next-line no-console -- logger centralizado; erros devem ser logados
  error: (...args: unknown[]) => console.error(...args),
};
